var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        "close-on-click-modal": false,
        title: _vm.$t("WriteOff.modifyMatchStatus"),
        width: "400px"
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "100px", "label-position": "left" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("WriteOff.modifyStatus") } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: _vm.$t("WriteOff.modifyStatus") },
                  model: {
                    value: _vm.form.writeoffMatchStatus,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "writeoffMatchStatus", $$v)
                    },
                    expression: "form.writeoffMatchStatus"
                  }
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("WriteOff.matchStatusManual"),
                      value: 2
                    }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("WriteOff.matchStatusNoNeed"),
                      value: 3
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("WriteOff.modifyReason") } },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 3 },
                model: {
                  value: _vm.form.writeoffMatchStatusReason,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "writeoffMatchStatusReason", $$v)
                  },
                  expression: "form.writeoffMatchStatusReason"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v(_vm._s(_vm.$t("WriteOff.confirmModify")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }